import HistoryIcon from '@mui/icons-material/History'
import SearchIcon from '@mui/icons-material/Search'
import { Box, Grid, InputAdornment, TextField as MuiTextField, Typography } from '@mui/material'
import { FC, useMemo, useState } from 'react'
import {
  Datagrid,
  DateField,
  ListContextProvider,
  Pagination,
  TextField,
  useGetList,
  useList,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { Samenwerking } from '../../types/apiRequests'

interface AuditLogEntry {
  id: string
  actor: string
  description: string
  created: string
}

const CollaborationsAuditLog: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<Samenwerking>()
  const [search, setSearch] = useState('')

  const { data, isLoading, error } = useGetList<AuditLogEntry>(
    `samenwerkingen/${record?.id}/auditlog`,
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'created', order: 'DESC' },
    },
    { enabled: !!record?.id }
  )

  const filtered = useMemo(() => {
    if (!data) return []
    if (!search.trim()) return data
    const q = search.toLowerCase()
    return data.filter(
      entry => entry.actor?.toLowerCase().includes(q) || entry.description?.toLowerCase().includes(q)
    )
  }, [data, search])

  const listContext = useList<AuditLogEntry>({ data: filtered, isLoading, perPage: 10 })

  if (isLoading) return <div />
  if (error) {
    return (
      <Typography color="error">
        {translate('ra.notification.http_error')}
      </Typography>
    )
  }

  return (
    <Grid container spacing={3}>
      <Grid item md={12}>
        <Box
          sx={{
            border: 1,
            borderColor: 'grey.300',
            borderRadius: 1,
            p: 2,
            height: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
              <HistoryIcon sx={{ mr: '10px' }} fontSize="small" />
              {translate('show.audit')}
            </Typography>
            <MuiTextField
              size="small"
              placeholder={translate('ra.action.search')}
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              sx={{ width: 250 }}
            />
          </Box>

          <ListContextProvider value={listContext}>
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
            >
              <DateField
                label="data.date"
                source="created"
                showTime
              />
              <TextField
                label="data.auditActor"
                source="actor"
              />
              <TextField
                label="data.auditDescription"
                source="description"
              />
            </Datagrid>
            <Pagination />
          </ListContextProvider>
        </Box>
      </Grid>
    </Grid>
  )
}

export default CollaborationsAuditLog
